import React from 'react'
import { BFormGroup, BCheckbox, BFormText } from '@prague-digi/ui-components'
import { Field } from 'redux-form'

import { fieldAdapter, FieldProps } from '../../utils/field'

import styles from './styles.scss'

// Supply a 'message' as the text; or a whole object of messages including
// an extra note or error message; 'messages.label' is then used for the
// checkbox text.

interface Props {
  name: string
  testid: string
  message?: any
  messages?: {
    label?: string
    notice?: string
    warning?: string
    error?: string
  }
  [x: string]: any
}

const Checkbox: React.FunctionComponent<Props & FieldProps> = (props: Props & FieldProps) => {
  const { label, notice, warning, error } = props.messages || {
    label: props.message,
    notice: undefined,
    warning: undefined,
    error: undefined,
  }
  const errorStyle = error ? styles.error : undefined

  return (
    <BFormGroup error={!!error} warning={!!warning}>
      <BCheckbox {...props} message={label} theme={errorStyle} checked={props.value} />
      {(notice || error || warning) && (
        <p>
          {notice && <BFormText>{notice}</BFormText>}
          {error && <BFormText>{error}</BFormText>}
          {warning && <BFormText>{warning}</BFormText>}
        </p>
      )}
    </BFormGroup>
  )
}

export const renderCheckbox = fieldAdapter(Checkbox)
export const CheckboxField: React.FunctionComponent<Props> = (props: Props) => (
  <Field {...props} component={renderCheckbox} />
)
export default CheckboxField
